import React from "react";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import ListItemText from "@material-ui/core/ListItemText";
import MenuList from "@material-ui/core/MenuList";
import MenuItem from "@material-ui/core/MenuItem";

import RegularButton from "@components/buttons/RegularButton";
import { ThemeType } from "@theme";

import { TextEditorTemplate } from "./TextEditor";
import { makeStyles } from "@material-ui/core/styles";

type Props = {
  open: boolean;
  onClose: (e: React.SyntheticEvent<any>) => any;
  onSelect: (template: TextEditorTemplate) => any;
  templates: TextEditorTemplate[];
};

export function TemplateSelector(props: Props) {
  const classes = useStyles({});
  return (
    <Dialog open={props.open} onClose={props.onClose}>
      <DialogTitle>Select a template</DialogTitle>

      <DialogContent>
        <MenuList>
          {props.templates.map((template) => (
            <MenuItem
              className={classes.item}
              key={template.id}
              disableGutters
              value={template.id}
              onClick={() => props.onSelect(template)}
            >
              <ListItemText>{template.title}</ListItemText>
              <ListItemText className={classes.content}>{template.content}</ListItemText>
            </MenuItem>
          ))}
        </MenuList>
      </DialogContent>

      <DialogActions>
        <RegularButton onClick={props.onClose}>Close</RegularButton>
      </DialogActions>
    </Dialog>
  );
}

TemplateSelector.defaultProps = {
  templates: []
};

const useStyles = makeStyles((theme: ThemeType) => ({
  item: {
    flexWrap: "wrap",
    height: "auto",

    "& > div": {
      height: "auto",
      flexBasis: "100%",
      padding: 0
    },

    "& span": {
      whiteSpace: "normal"
    }
  },

  content: {
    "& > span": {
      fontWeight: theme.typography.fontWeightLight
    }
  }
}));
